import React from 'react';
import { Flex, Typography } from 'antd';

import { StepTitle } from '../../steps/StepTitle';
import { StepList } from '../../steps/StepList';

const { Text } = Typography;
export const RobokassaStepInit = () => {
    return (
        <Flex vertical gap={8}>
            <StepTitle text={'Шаг 1. Регистрация в Робокассе'} />

            <StepList>
                <Text>Для подключения оплаты необходимо:</Text>
                <Text>1. создать магазин</Text>
                <Text>
                    2. зайти в технические настройки и сгенерировать пару пароль
                    #1 и пароль #2, алгоритм шифрования - md5
                </Text>
                <Text>3. установить ResultUrl - /robokassa/notify</Text>
                <Text>4. установить SuccessUrl - /robokassa/success</Text>
                <Text>5. установить FailUrl - /robokassa/fail</Text>
            </StepList>
        </Flex>
    );
};
